<template>
  <div id="app">
    <div class="hide">
      <svg version="1.1" id="arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="10px" height="10px" viewBox="0 0 444 444" style="fill:#ffffff;transform:scale(0.5)"
    xml:space="preserve">
      <g>
          <path d="M421.976,196.712L236.111,10.848C228.884,3.615,220.219,0,210.131,0c-9.9,0-18.464,3.615-25.697,10.848L163.023,32.26
              c-7.234,6.853-10.85,15.418-10.85,25.697c0,10.277,3.616,18.842,10.85,25.697l83.653,83.937H45.677
              c-9.895,0-17.937,3.568-24.123,10.707s-9.279,15.752-9.279,25.837v36.546c0,10.088,3.094,18.698,9.279,25.837
              s14.228,10.704,24.123,10.704h200.995L163.02,360.88c-7.234,7.228-10.85,15.89-10.85,25.981c0,10.089,3.616,18.75,10.85,25.978
              l21.411,21.412c7.426,7.043,15.99,10.564,25.697,10.564c9.899,0,18.562-3.521,25.981-10.564l185.864-185.864
              c7.043-7.043,10.567-15.701,10.567-25.981C432.54,211.939,429.016,203.37,421.976,196.712z"/>
      </g>
    </svg>
    <svg id="forbidden" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7 14h-14v-4h14v4z"/></svg>
    <svg version="1.1" id="print" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M475.934,108.229H380.35V54.285c0-5.995-4.862-10.857-10.857-10.857H142.507c-5.995,0-10.857,4.862-10.857,10.857v53.945
			H36.066C16.179,108.229,0,124.409,0,144.296v172.837C0,337.02,16.179,353.2,36.066,353.2h95.584v104.515
			c0,5.995,4.862,10.857,10.857,10.857h226.987c5.995,0,10.857-4.862,10.857-10.857V353.2h95.584
			c19.886,0,36.066-16.179,36.066-36.067V144.296C512,124.409,495.82,108.229,475.934,108.229z M380.349,129.942h25.897v30.385
			h-25.897V129.942z M153.363,65.142h205.273v95.186H153.363V65.142z M105.753,129.943h25.897v30.385h-25.897V129.943z
			 M358.637,446.858H153.363V303.879h205.273V446.858z M490.288,317.133h-0.001c0,7.915-6.439,14.354-14.352,14.354H380.35v-27.607
			h19.805c5.995,0,10.857-4.862,10.857-10.857s-4.862-10.857-10.857-10.857h-30.661H142.507h-30.661
			c-5.995,0-10.857,4.862-10.857,10.857s4.862,10.857,10.857,10.857h19.805v27.607H36.066c-7.913,0-14.352-6.439-14.352-14.354
			V144.296c0-7.914,6.439-14.354,14.352-14.354H84.04v41.241c0,5.995,4.861,10.857,10.857,10.857h322.207
			c5.995,0,10.857-4.862,10.857-10.857v-41.241h47.974c7.913,0,14.353,6.439,14.353,14.354V317.133z"/>
	</g>
</g>
<g>
	<g>
		<circle cx="68.799" cy="219.261" r="13.602"/>
	</g>
</g>
<g>
	<g>
		<path d="M252.849,386.456h-50.68c-5.995,0-10.857,4.86-10.857,10.857c0,5.995,4.861,10.857,10.857,10.857h50.68
			c5.995,0,10.857-4.862,10.857-10.857C263.706,391.316,258.844,386.456,252.849,386.456z"/>
	</g>
</g>
<g>
	<g>
		<path d="M309.831,331.483H202.169c-5.995,0-10.857,4.862-10.857,10.857c0,5.996,4.861,10.857,10.857,10.857h107.661
			c5.995,0,10.857-4.861,10.857-10.857C320.687,336.345,315.826,331.483,309.831,331.483z"/>
	</g>
</g>
</svg>
<svg version="1.1" id="attention" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<path style="fill:#464655;" d="M509.435,448.962L271.75,44.367c-7.076-12.045-24.424-12.045-31.5,0L2.565,448.962
	c-7.194,12.245,1.595,27.705,15.75,27.705h475.368C507.839,476.666,516.629,461.207,509.435,448.962z"/>
<path style="fill:#5B5D6E;" d="M310.09,109.633c-75.525,54.5-124.731,143.208-124.731,243.46c0,44.069,9.578,85.877,26.64,123.573
	h281.685c14.155,0,22.944-15.459,15.75-27.705L310.09,109.633z"/>
<path style="fill:#FFDC64;" d="M252.195,93.738L53.788,431.474c-2.57,4.374,0.585,9.885,5.658,9.885h393.11
	c5.073,0,8.228-5.511,5.658-9.885L259.805,93.738C258.099,90.834,253.901,90.834,252.195,93.738z"/>
<path style="fill:#FFF082;" d="M185.36,353.093c0,30.722,4.638,60.357,13.216,88.267h253.98c5.073,0,8.228-5.511,5.658-9.885
	L282.389,132.181C222.755,187.029,185.36,265.683,185.36,353.093z"/>
<g>
	<circle style="fill:#464655;" cx="256.028" cy="379.568" r="17.653"/>
	<path style="fill:#464655;" d="M239.049,213.171l7.566,113.485c0.33,4.948,4.174,8.784,8.805,8.784h1.216
		c4.631,0,8.475-3.834,8.805-8.784l7.566-113.485c0.365-5.475-3.682-10.131-8.805-10.131h-16.347
		C242.731,203.04,238.684,207.697,239.049,213.171z"/>
</g>
<path style="fill:#FFC850;" d="M452.556,450.186H59.442c-5.499,0-10.62-2.966-13.353-7.741c-2.733-4.78-2.698-10.697,0.086-15.442
	L244.587,89.258c2.405-4.086,6.672-6.525,11.422-6.525c4.741,0,9.008,2.439,11.413,6.525l198.401,337.744
	c2.784,4.75,2.819,10.667,0.086,15.442C463.176,447.22,458.055,450.186,452.556,450.186z M63.399,432.533h385.201L255.998,104.684
	L63.399,432.533z"/>
<path style="fill:#FFDC64;" d="M448.599,432.533H196.069c1.633,5.964,3.455,11.844,5.441,17.653h251.048
	c5.499,0,10.62-2.966,13.353-7.741c2.733-4.775,2.698-10.692-0.086-15.442L289.135,126.224c-4.553,3.944-9,8.005-13.307,12.212
	L448.599,432.533z"/>
<g>
</g>
</svg>
  </div>
    <div class="container">
      <div class="clouds"><img src="./assets/clouds.svg" width="940"></div>
      <!--<div class="logo"><img src="./assets/logo.png"></div>-->
      <div class="header">
        <h1><router-link to="/">Constituez la trousse à pharmacie idéale !</router-link></h1>
      </div>
      <div class="restart hide">
        <router-link to="/"><svg><use xlink:href="#arrow"></use></svg>Recommencer</router-link>
      </div>
      <div class="btConclusion hide">
        <router-link to="/conclusion">Que faire face à un arrêt cardiaque ?</router-link>
      </div>
      <router-view></router-view>

      <div class="overlay hide"></div>

      <div class="popin">
        <div class="popin-close" @mousedown="closePopin">✕</div>
        <div class="popin-title">COMMENT JOUER ?</div>
        <div class="popin-subtitle">Faites <span>glisser-déposer</span> les objets à l'aide de la souris :</div>
        <div class="popin-element1"><img src="./assets/pansements.png"></div>
        <div class="popin-element2"><img src="./assets/carte_vitale.png"></div>
        <div class="popin-table">
          <div>Déposez-les vers la &laquo; <span>trousse à pharmacie</span> &raquo; si vous pensez qu'ils sont <span>incontournables</span>.<br>
          <img src="./assets/sac_pharmacie.png" class="sac"><br></div>
          <div>Déposez-les vers la &laquo; <span>pochette à pharmacie</span> &raquo; si vous pensez qu'ils sont <span>optionnels</span>.<br>
          <img src="./assets/trousse_pharmacie.png" class="trousse"><br></div>
        </div>
        <div class="popin-mention">Attention : des objets <span>interdits</span> se sont glissés parmi les produits.</div>
        <button @mousedown="closePopin"><svg><use xlink:href="#arrow"></use></svg> Jouer</button>
      </div>

      <div class="popinResult hide">
        <div class="popin-close" @mousedown="closePopinResult">✕</div>
        <div class="popinResult-title"></div>
        <div class="popinResult-img"></div>
        <div class="popinResult-correct">
          <span>✔</span>
          <span>✘</span>
          <span><svg><use xlink:href="#forbidden"></use></svg></span>
        </div>
        <div class="popinResult-description"></div>
        <button @mousedown="closePopinResult"><svg><use xlink:href="#arrow"></use></svg> Continuer</button>
      </div>

      <router-link to="/conclusion"><button class="buttonPrint" @mousedown="closePopin"><svg><use xlink:href="#arrow"></use></svg> Imprimer la liste</button></router-link>
      <router-link to="/"><button class="buttonChange"><svg><use xlink:href="#arrow"></use></svg> Changer de profil</button></router-link>
      <router-link to="/"><button class="buttonRestart"><svg><use xlink:href="#arrow"></use></svg> Recommencer le jeu</button></router-link>
    </div>
  </div>
</template>

<script>
import Enceinte from './components/1-Enceinte'
import Enfants from './components/2-Enfants'
import Couple from './components/3-Couple'
import Conclusion from './components/4-Conclusion'
  
export default {
  name: 'app',
  components: {
    Enceinte, Enfants, Couple, Conclusion
  },
  created: function() {
    // CLOSEST (FOR IE)
    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = 
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i,
            el = this;
        do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) {};
        } while ((i < 0) && (el = el.parentElement)); 
        return el;
      };
    }
    this.parseJson();
  },
  mounted: function() {    
    this.changeImgs(this.$el.querySelectorAll("img")); // PROD
  },
  methods: {
    closePopin: function() {
      this.closePopinMixin();
      
      let items = document.querySelectorAll(".items img");
      for(let i=0; i < items.length; i++) {
        TweenLite.from(items[i], 0.6, { alpha:0, scale:0, ease:Quad.easeOut, delay:i/50 });
      }
    },
    closePopinResult: function() {
      this.closePopinMixin(false);
    }
  }
}
</script>

<style lang="scss" scoped>

@import "common.scss";
  
body {
  margin: 0;
}
#app {
  font-family: 'Nunito', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.container {
  width: 940px;
  height: 530px;
  border: 1px solid $red;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  .clouds {
    position: absolute;
    z-index: -1;
    background: rgb(255,255,255);
    background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(204,238,255,1) 100%);
    img {
      margin-top: 30px;
    }
  }
  .logo {
    position: absolute;
    top: 15px;
    left: 15px;
  }
  .header {
    width: 800px;
    margin: 0 auto 0 150px;
  }
  h1 {
    font-size: 20px;
    margin: 0 auto;
    padding: 10px;
    font-weight: normal;
    text-transform: uppercase;
    background-color: $taupe;
    a {
      text-decoration: none;
      color: #fff;
    }
  }
  .next, .btConclusion {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    font-size: 13px;
    background-color: $red;
    border-top-left-radius: 15px;
    padding: 0 5px 0 15px;
    text-decoration: none;
    color: #fff;
    transition: 0.5s background-color;
    &:hover {
      cursor: pointer;
      background-color: darken($red, 10%);
    }
    a {
      text-decoration: none;
      color: #fff;
    }
  }
  .restart {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    font-size: 13px;
    background-color: $red;
    border-top-right-radius: 15px;
    padding: 0 5px 0 15px;
    a {
      text-decoration: none;
      color: #fff;
      margin-right: 10px;
    }
    svg {
      -moz-transform: scaleX(-1);
      -o-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
      filter: FlipH;
      -ms-filter: "FlipH";
    }
  }
  /*
  svg {
    fill: #fff;
    width: 10px;
    height: 10px;
    margin: 5px 10px 0px 0;
  }
  */
}

</style>



// WEBPACK FOOTER //
// App.vue?7197632e